import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a0884c8e&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=a0884c8e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0884c8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0884c8e')) {
      api.createRecord('a0884c8e', component.options)
    } else {
      api.reload('a0884c8e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a0884c8e&scoped=true&lang=pug", function () {
      api.rerender('a0884c8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parents/profileInfo/infoCard/viewInfoCard/index.vue"
export default component.exports